import { _creditForCaseToCase } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface GetHospitalCaseCreditsPayload {
  _id: string;
}

export const getCaseToCaseHospital = createAsyncThunk(
  'getCaseToCaseHospital/get',
  async (payload: GetHospitalCaseCreditsPayload | undefined, thunkAPI) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const url = `${_creditForCaseToCase.getCaseToCaseHospital}`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      return thunkAPI.rejectWithValue(`Failed to fetch case credits: ${errorText}`);
    }

    const data = await response.json();

    return {
      data: data.data,
      status: data.status,
      msg: data.msg,
    };
  }
);
